import { Component, forwardRef, Input, OnInit, ViewChild } from "@angular/core";
import { FilterCardWithCode } from "app/modules/dashboard/constants/filters";
import { GridComponent } from "@app/modules/shared/components/grid/grid.component";

@Component({
  selector: "kl-taxarea-list",
  templateUrl: "./taxarea-list.component.html",
  styleUrls: ["./taxarea-list.component.scss"],
})
export class TaxareaListComponent implements OnInit {
  filterSelectItems = FilterCardWithCode;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() mode: string;
  @Input() dblSelect = false;
  @ViewChild(forwardRef(() => GridComponent), { static: true })
  private gridComponent: GridComponent;

  constructor() {}

  ngOnInit() {
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
  }
}
